import {stripZeros} from 'Shared/backend/menu/Price';
import {For, Show} from 'solid-js';
import { css } from '@emotion/css';
import { theme, palette, sizes } from 'Shared/frontend/SettingsProvider';
import { useUrls } from 'Shared/SiteProvider';
import { calculateProductType } from 'Shared/backend/menu/MenuDesignerPage';


const itemStyle = (isPreview:boolean) => css({
	display: 'block',
	maxWidth: isPreview ? 'min(100%,450px)' : '450px',
	backgroundColor: palette().dimBackground,

	[`@media (max-width:${sizes().flipToMobileNav}px)`]: {
    	width: '100vw', 
	}
});

const imageStyle = () => css({
	width: '100%',
});

const detailsWrapStyle = () => css({
    display: 'flex',
    padding: '1em',
    flexDirection: 'column',
    justifyContent: 'space-between',
	fontSize: 24,
	letterSpacing: '0.1em',
	lineHeight: 1.2,

	['@media (max-width: 600px)']: {
		padding: 10
	},

	[`@media (min-width:${sizes().flipToMobileNav}px)`]: {
		/* Using a margin here causes a problem in preview */
		paddingBottom: '2em'
	},
});

const titleWrapStyle = () => css({
	marginBottom: '0.5em'
});

const titleStyle = (productType,section) => css(
	theme().item.title,
	theme().item.titleType(productType,section)
);

const smallStyle = () => css({
	fontSize: '0.7em'
});

const unitStyle = () => css({
	fontSize: '0.8em'
});

const priceInnerStyle = () => css({
	textAlign: 'right'
});

const priceWrapStyle = () => css(theme().item.price,{
	marginTop: '1em'
});

const descriptionStyle = () => css({
	fontSize: '0.8em'
});	


interface IOverlayItem {
	isPreview: boolean;
	item;
	section;
	productType:string;
}

export function OverlayItem(P:IOverlayItem) 
{
	const productType = () => calculateProductType(P.menu,P.location);

//TODO helper function	
	const imageUrl = () => {
		if (!P.item.image?.hash)
			return '';
		return useUrls().createImageUrl(P.item.image.hash,P.item.image,'MenuItem-image','medium');
	};

	return (<>
		<div class={itemStyle(P.isPreview)}>
			<img class={imageStyle()} src={imageUrl()} />

			<div class={detailsWrapStyle()}>
				<TitleWrap {...P} productType={productType()} />

				<div class={descriptionStyle()}>
					{P.item.tagline}
				</div>

				<MenuItemPrices item={P.item}/>
			</div>
		</div>
	</>);
}

export function TitleWrap(P:IOverlayItem)
{
	const tags = () => P.item.tags ?? [];

	//FIXME townie specific
	const tagsStr = () => tags().filter(i => i!='0%' && i!='☺').join(' ');

	return (
		<div class={titleWrapStyle()}>
			<span class={titleStyle(P.productType,P.section)}>
				{P.item.brandName} {P.item.name}
				<Show when={tags().includes('0%')}>
					{' '}0%
				</Show>
				<Show when={tags().includes('☺')}>
					{' '}☺
				</Show>
			</span>
			<Show when={P.item.variety}>
				{' '}
				<span class={smallStyle()}>{P.item.variety} {P.item.varietyOther}</span>
			</Show>
			<Show when={tagsStr().length > 0 }>
				{' '}
				<span class={smallStyle()}> 
					({tagsStr()})
				</span>
			</Show>

			<Show when={P.item.year || P.item.region || P.item.state || P.item.country }>
				{' '}
				<span class={smallStyle()}>
					{P.item.year} {P.item.region} {P.item.state?.toUpperCase()}
					<Show when={P.item.country != 'Australia'}>
						{' '}
						{P.item.country}
					</Show>
				</span>
			</Show>
		</div>
	);
}

export function MenuItemPrices(props)
{
	return (
		<div class={priceWrapStyle()}>
			<For each={props.item.prices}>{ unit =>
				<Show when={unit.price !== null }>
					{/* XXX probably shouldnt be required but currently these items contain nulls */}
					<div class={priceInnerStyle()}>
						{/* Only 1 of these unit options will appear */}
						<span class={unitStyle()}>{capitalise(unit.size)}{capitalise(unit.description)}{' '}</span>
						<span>${stripZeros(unit.price)}</span>
					</div>
				</Show>
			}</For>
		</div>
	);
}

function capitalise(s:string) 
{
	const str = s ?? '';
    return str.charAt(0).toUpperCase() + str.slice(1);
}

